export default __webpack_public_path__ + "static/media/ultralight.b3a305eb.png";